import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiPost } from '../utils/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters'); return; }
    setError(''); setLoading(true);
    try {
      await apiPost('/auth/reset-password', { token, password });
      setSuccess('Password reset successfully! You can now sign in with your new password.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <div className="emblem">💧</div>
            <h1>Advanced Waste Water Treatment Corp</h1>
            <p>Waste Profile Management Portal</p>
          </div>
          <div className="alert alert-error">Invalid or missing reset token. Please request a new password reset.</div>
          <Link to="/login" className="btn btn-secondary" style={{ marginTop: 12, display: 'block', textAlign: 'center' }}>
            Back to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="emblem">💧</div>
          <h1>Advanced Waste Water Treatment Corp</h1>
          <p>Waste Profile Management Portal</p>
        </div>
        <h2>Reset Password</h2>
        {success ? (
          <div>
            <div className="alert alert-success">{success}</div>
            <Link to="/login" className="btn btn-primary" style={{ marginTop: 12, display: 'block', textAlign: 'center' }}>
              Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="form-grid">
            {error && <div className="alert alert-error">{error}</div>}
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={password}
                onChange={e => setPassword(e.target.value)} required autoFocus />
              <span className="form-hint">Minimum 8 characters</span>
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input type="password" value={confirm}
                onChange={e => setConfirm(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset Password'}
            </button>
            <Link to="/login" style={{ textAlign: 'center', fontSize: 13, color: 'var(--ink-lt)' }}>
              Back to Sign In
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
